module.exports = __webpack_public_path__ + "static/gallery-13-172008739ea4c0a231bf6af1a6a7a7ae.jpg";